module.exports = __webpack_public_path__ + "static/media/fsa.2c4fc08f.png";